/* eslint-disable import/first */
/**
 * IE patch
 */
/* eslint-disable */
import Promise from 'promise'
self.Promise = Promise
import 'whatwg-fetch'
import debug from './core/debug'

import registerPromiseWorker from 'promise-worker/register'
import { generateKey as generateKeyPair, exportJWK, exportPEM, wrapKey, unwrapKey, testKeys as testKeyPair } from './cryptography/rsa'
import { generateKey as generateAESKey, listKeys, decrypt, encrypt, fetchKeyUrls, KEY_SIZE } from './cryptography/aes'
import { base64encode, base64decode } from './cryptography/util'
/* eslint-enable */

const actions = {
  greet (name) {
    return 'Hi ' + name
  },
  setCookie (cookie) {
    self.cookie = cookie
    return true
  },
  generateKeyPair () {
    return generateKeyPair().then(pair => ({ ...exportJWK(pair), ...exportPEM(pair) }))
  },
  generateKey () {
    return generateAESKey().then(wrapKey).then(base64encode)
  },
  generateUnwrappedKey () {
    return generateAESKey().then(base64encode)
  },
  listKeys () {
    return listKeys()
  },
  decrypt (enc) {
    return decrypt(enc)
  },
  encrypt (text) {
    return encrypt(text)
  },
  exportKeys () {
    return fetchKeyUrls(10000).then(({ data }) => data.map(({ uri, urn }) => `${urn} ${uri}`).join('\n'))
  },
  unwrapKey (key) {
    return unwrapKey(base64decode(key)).then(base64encode).catch(e => {
      const decoded = base64decode(key)
      if (decoded.length !== KEY_SIZE) {
        throw new Error('Key not valid')
      }
      return decoded
    })
  },
  testKeyPair ({ privateJWK = null, publicJWK = null, privatePEM = null, publicPEM = null }, algorithm, keyFormat) {
    return testKeyPair({ privateJWK, publicJWK, privatePEM, publicPEM }, algorithm, keyFormat)
  }
}

registerPromiseWorker(function (message) {
  try {
    const { action, args = [] } = JSON.parse(message)
    const timerName = `Worker ${action}`
    debug.time(timerName)
    return Promise.resolve(actions[action].apply(actions, args))
      .then((result) => debug.timeEnd(timerName) || JSON.stringify({
        ok: true,
        result
      }))
      .catch(e => debug.timeEnd(timerName) || JSON.stringify({
        ok: false,
        error: e.message
      }))
  } catch (e) {
    return JSON.stringify({
      ok: false,
      error: e.message
    })
  }
})
